export class Route {
  page: string;
  param: any;
  ref: string;

  navigateTo(page, param, ref) {
    this.page = page;
    this.param = param;
    this.ref = ref;
  }
}

/*
 * Service route
 */
angular.module('posApp').factory('route', () => {
  return new Route();
});
